
import React from 'react';

import {Helmet} from 'views/module';

import PersonalDashboard from 'views/scenes/dashboard/PersonalDashboard';

const App = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <PersonalDashboard
      />
    </>
  );
};

export default App;
